import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { useDeletePatientHistoryEntry } from '../../../api/useDeletePatientHistoryEntry'
import DialogHeader from '../../../components/DialogHeader'
import { useDisabledInPreview } from '../../../dashboard/panelPreviewContext'
import { FieldError } from '../../fieldPrimitives'

const DeleteEntryButton = ({ uid, entryID, label }: { uid: string; entryID: string; label: string }) => {
  const [open, setOpen] = useState(false)
  const { remove, deleting, error } = useDeletePatientHistoryEntry(uid)
  const disabled = useDisabledInPreview(deleting)

  const onDelete = async () => {
    try {
      await remove(entryID)
      setOpen(false)
    } catch {
      // The hook's `error` already carries the message the dialog shows.
    }
  }

  return (
    <>
      <IconButton aria-label={`Delete ${label}`} size="small" disabled={disabled} onClick={() => setOpen(true)}>
        <DeleteOutlineRoundedIcon fontSize="small" />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogHeader title="Delete entry" onClose={() => setOpen(false)} />
        <DialogContent>
          <DialogContentText>{`Delete this ${label} entry? This cannot be undone.`}</DialogContentText>
          <FieldError message={error?.message ?? null} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button color="error" variant="contained" disabled={disabled} onClick={onDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteEntryButton
